function isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}

export { isObjectLike };
